// src/pages/SolicitudesSoporte.js
import React, { useEffect, useMemo, useState } from 'react';
import { collection, getDocs, orderBy, query, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { FaInbox, FaCheck, FaTimes, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import './SolicitudesSoporte.css';

const StatusBadge = ({ status }) => {
  const s = String(status || '').toLowerCase();
  const label = s || 'pendiente';
  return <span className={`status-badge ${label}`}>{label}</span>;
};

const SolicitudesSoporte = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const counters = useMemo(() => {
    const c = { pendiente: 0, contactada: 0, resuelta: 0, rechazada: 0 };
    items.forEach((i) => { c[String(i.status || 'pendiente').toLowerCase()] = (c[String(i.status || 'pendiente').toLowerCase()] || 0) + 1; });
    return c;
  }, [items]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const q = query(collection(db, 'supportRequests'), orderBy('createdAt', 'desc'));
        const snap = await getDocs(q);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setItems(list);
      } catch (err) {
        console.error('No se pudieron cargar solicitudes de soporte', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const setStatus = async (id, status) => {
    try {
      await updateDoc(doc(db, 'supportRequests', id), { status });
      setItems((prev) => prev.map((i) => (i.id === id ? { ...i, status } : i)));
    } catch (err) {
      console.error('No se pudo actualizar estado', err);
    }
  };

  return (
    <div className="support-admin-page">
      <div className="header">
        <FaInbox />
        <div>
          <h2>Solicitudes de Soporte</h2>
          <p>Revisa y gestiona las solicitudes enviadas por los usuarios.</p>
        </div>
      </div>

      <div className="summary">
        <div><strong>{counters.pendiente || 0}</strong><span>Pend.</span></div>
        <div><strong>{counters.contactada || 0}</strong><span>Contact.</span></div>
        <div><strong>{counters.resuelta || 0}</strong><span>Resueltas</span></div>
        <div><strong>{counters.rechazada || 0}</strong><span>Rech.</span></div>
      </div>

      <div className="list">
        {loading ? <p className="loading">Cargando…</p> : null}
        {items.map((item) => (
          <div key={item.id} className="row">
            <div className="main">
              <h4>{item.asunto || 'Sin asunto'}</h4>
              <p className="meta">
                {item.nombre ? <span>{item.nombre}</span> : null}
                {item.fraccionamiento ? <span>{item.fraccionamiento}</span> : null}
                {item.categoria ? <span>{item.categoria}</span> : null}
              </p>
              <p className="message">{item.mensaje}</p>
            </div>
            <div className="side">
              <StatusBadge status={item.status} />
              <div className="contact">
                {item.telefono ? <span><FaPhoneAlt /> {item.telefono}</span> : null}
                {item.correo ? <span><FaEnvelope /> {item.correo}</span> : null}
              </div>
              <div className="actions">
                <button onClick={() => setStatus(item.id, 'contactada')} className="btn contact"><FaCheck /> Contactada</button>
                <button onClick={() => setStatus(item.id, 'resuelta')} className="btn success"><FaCheck /> Resuelta</button>
                <button onClick={() => setStatus(item.id, 'rechazada')} className="btn danger"><FaTimes /> Rechazar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SolicitudesSoporte;
